module.exports = __webpack_public_path__ + "static/media/MenuCupcakes.8a5ee858.jpg";